import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import vectorIcon1 from "../../../../Assets/Images/Vector.png";
import vectorIcon2 from "../../../../Assets/Images/format_quote-Down-icon.png";

const testimonials = [
  {
    id: 1,
    text: "We did not have everything figured out at the start, and that worried me. The team helped us think things through as we went and built something that actually fits how we work day to day.",
    name: "Gazi",
    title: "Operations Manager of Paragon Hotel and Resort",
    img: "https://i.ibb.co.com/S7PhGVP3/Icon-15.png",
  },
  {
    id: 2,
    text: "There were a lot of moving parts and some difficult technical decisions. What I liked most was the way that the team was so transparent and they were able to adapt when we needed to change direction.",
    name: "Leo Kameni",
    title: "Founder, GO5050",
    img: "https://go5050.co.uk/images/logos/go5050logo2.png",
  },
];

export default function ClientTestimony() {
  const [currentIndex, setCurrentIndex] = useState(0); // 0 → [0,1], 1 → [1,2], 2 → [2,0]
  const [isMobile, setIsMobile] = useState(false);

  // Responsive setup
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 576);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Auto-rotate every 3s
  const total = testimonials.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 3000);
    return () => clearInterval(interval);
  }, [total]);

  const handleClick = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };


  const frontIdx = currentIndex;
  const backIdx = (currentIndex + 1) % total;

  const frontTestimonial = testimonials[frontIdx];
  const backTestimonial = testimonials[backIdx];

  return (
    <div id="our-stories">
      <div
        id="stories"
        className=""
        style={{ background: "#E8F8FC", marginTop: "" }}
      >
        <div
          className="d-flex justify-content-center align-items-center flex-column"
          style={{
            paddingTop: isMobile ? "2rem" : "7rem",
            paddingBottom: isMobile ? "2rem" : "6rem",
          }}
        >
          <h4
            className="fw-semibold Tech-heading text-dark py-5"
            style={{
              marginBottom: 24,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Stories From Our Amazing Clients
          </h4>

          <div
            className="position-relative"
            style={{
              width: isMobile ? "280px" : "440px",
              height: isMobile ? "480px" : "380px",
              cursor: "pointer",
            }}
            onClick={handleClick}
          >
            {/* Front card (higher z-index, animates faster) */}
            <motion.div
              key={`front-${currentIndex}`}
              initial={{ x: isMobile ? -10 : -20, y: isMobile ? -10 : -20 }}
              animate={{ x: isMobile ? 10 : 20, y: isMobile ? 10 : 20 }}
              transition={{ duration: 1.1, ease: "easeInOut" }}
              className="position-absolute shadow rounded-4 overflow-hidden"
              style={{
                width: "100%",
                height: "100%",
                zIndex: 3,
                background: "#E8F8FC",
                border: "2px solid #ffffff",
                boxSizing: "border-box",
              }}
            >
              <div className="d-flex flex-column justify-content-between h-100">
                <div
                  style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 4 }}
                >
                  <p
                    className="text-secondary fs-3"
                    style={{ marginBottom: 8 }}
                  >
                    <img src={vectorIcon2} alt="quote start" />
                  </p>
                  <p
                    className="text-secondary small d-flex justify-content-center align-items-center"
                    style={{
                      paddingTop: 24,
                      paddingBottom: 24,
                      textAlign: "justify",
                      fontSize: "1.5rem",
                    }}
                  >
                    {frontTestimonial.text}
                  </p>
                  <p
                    className="text-secondary fs-3 text-end"
                    style={{ marginBottom: 0 }}
                  >
                    <img src={vectorIcon1} alt="quote end" />
                  </p>
                </div>

                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "16px 20px",
                  }}
                  className="d-flex align-items-center"
                >
                  <img
                    src={frontTestimonial.img}
                    alt={frontTestimonial.name}
                    className="rounded-circle"
                    width={50}
                    height={50}
                    style={{ marginRight: 12 }}
                  />
                  <div>
                    <h6 className="text-dark" style={{ margin: 0 }}>
                      {frontTestimonial.name}
                    </h6>
                    <small style={{ fontSize: "10px" }}>
                      {frontTestimonial.title}
                    </small>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Back card (lower z-index, animates slower — appears "behind") */}
            <motion.div
              key={`back-${currentIndex}`}
              initial={{ x: isMobile ? 10 : 20, y: isMobile ? 10 : 20 }}
              animate={{ x: isMobile ? -10 : -20, y: isMobile ? -10 : -20 }}
              transition={{ duration: 2.2, ease: "easeInOut" }}
              className="position-absolute shadow rounded-4 overflow-hidden"
              style={{
                width: "100%",
                height: "100%",
                zIndex: 1,
                background: "#E8F8FC",
                border: "2px solid #ffffff",
                boxSizing: "border-box",
              }}
            >
              <div className="d-flex flex-column justify-content-between h-100">
                <div
                  style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 4 }}
                >
                  <p
                    className="text-secondary fs-3"
                    style={{ marginBottom: 8 }}
                  >
                    <img src={vectorIcon2} alt="quote start" />
                  </p>
                  <p
                    className="text-secondary small d-flex justify-content-center align-items-center"
                    style={{
                      paddingTop: 24,
                      paddingBottom: 24,
                      textAlign: "justify",
                      fontSize: "1.5rem",
                    }}
                  >
                    {backTestimonial.text}
                  </p>
                  <p
                    className="text-secondary fs-3 text-end"
                    style={{ marginBottom: 0 }}
                  >
                    <img src={vectorIcon1} alt="quote end" />
                  </p>
                </div>

                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "16px 20px",
                  }}
                  className="d-flex align-items-center"
                >
                  <img
                    src={backTestimonial.img}
                    alt={backTestimonial.name}
                    className="rounded-circle"
                    width={50}
                    height={50}
                    style={{ marginRight: 12 }}
                  />
                  <div>
                    <h6
                      className="text-dark"
                      style={{ margin: 0, fontSize: "1rem" }}
                    >
                      {frontTestimonial.name}
                    </h6>
                    <small
                      className="text-muted"
                      style={{
                        fontSize: "8px",
                        display: "block",
                        marginTop: "2px",
                      }}
                    >
                      {frontTestimonial.title?.trim() || "—"}
                    </small>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Indicator (3 dots / 3 positions) */}
          <div className="mt-3 py-5">
            <div
              style={{
                width: "60px",
                height: "4px",
                borderRadius: "3px",
                background: "#d9edf5",
                position: "relative",
              }}
            >
              <motion.div
                animate={{ x: currentIndex * 30 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                style={{
                  width: "30px",
                  height: "4px",
                  borderRadius: "3px",
                  background: "#19BDDE",
                  position: "absolute",
                  left: 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
